/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import SidebarRegular from '../components/SidebarRegular';
import DashboardHeader from '../components/DashboardHeader';
import BreadCrumbs from '../components/BreadCrumbs';

import Footer from '../components/Footer';

function Dashboard() {


    return (
        <div className="d-flex" style={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
            <SidebarRegular />
            <main className="flex-grow-1 p-4 d-flex flex-column" style={{ minWidth: 0, overflowY: 'auto', height: '100%' }}>
                <DashboardHeader />
                <BreadCrumbs />
                <div className="flex-grow-1">
                    <Outlet />
                </div>
                <Footer />
            </main>
        </div>
    );
}
export default Dashboard;
